export default __webpack_public_path__ + "static/media/profil.782073c1.png";